import { useSelector } from "react-redux";
import Contact from "./Contact";
import Address from "./Address";
import Instructions from "./Instructions";

const UserDetails = () => {
  const data = useSelector((state) => state.cart.data);
  if(data === null) return null;
  return (
    <div className="self-start md:sticky top-0 w-full md:w-[55%] xl:w-[60%] space-y-10">
      <Contact />
      <Address />
      <Instructions />
    </div>
  )
}

export default UserDetails